/**
 * @generated SignedSource<<f5cfce04a82da5ba377b22dd4a964162>>
 * @relayHash 9f2f4add783e1ef0c8ac25143de63bb1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 343873f539a88c9383d269865db402afd2f2415ec4a92a35e74b2499ae39fa92

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HelpCenterSettingsEmbeddedWidgetsAppQuery$variables = {
  helpCenterAri: string;
};
export type HelpCenterSettingsEmbeddedWidgetsAppQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly __typename: string;
    readonly widgets?: ReadonlyArray<{
      readonly __typename: string;
    } | null | undefined> | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"EmbeddedWidgets_AtlassianCsmWidgetConfiguration_EmbeddedWidgets">;
  } | null | undefined;
};
export type HelpCenterSettingsEmbeddedWidgetsAppQuery = {
  response: HelpCenterSettingsEmbeddedWidgetsAppQuery$data;
  variables: HelpCenterSettingsEmbeddedWidgetsAppQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "EMBED"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "HelpCenterSettingsEmbeddedWidgetsAppQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "widgets",
                "plural": true,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": "widgets(type:\"EMBED\")"
              }
            ],
            "type": "CsmAiHub"
          },
          {
            "kind": "FragmentSpread",
            "name": "EmbeddedWidgets_AtlassianCsmWidgetConfiguration_EmbeddedWidgets"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HelpCenterSettingsEmbeddedWidgetsAppQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "widgets",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "description"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isEnabled"
                      }
                    ],
                    "type": "CsmAiWidgetConfig"
                  }
                ],
                "storageKey": "widgets(type:\"EMBED\")"
              },
              (v4/*: any*/)
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "343873f539a88c9383d269865db402afd2f2415ec4a92a35e74b2499ae39fa92",
    "metadata": {},
    "name": "HelpCenterSettingsEmbeddedWidgetsAppQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "06ed5920ca5d58608793ee7dca91ac86";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
